import { optimizelyClient } from '@/scopes/common/infrastructure/ab-testing/optimizely/useOptimizely'
import { createNewRelicLogger } from '@/scopes/common/infrastructure/logging/newRelicLogger'
import { useCallback } from 'react'
import { useCookie } from 'react-use'

export function useSendOptimizelyEvent() {
  // Optimizely events are enabled by configuration per site, but we added a specific FF to be able to active it on acpt for testing without the need to deploy a new version of the app with the configuration change.
  const [userId] = useCookie('optimizelyEndUserId')
  const newRelicLogger = createNewRelicLogger({ scope: 'optimizelyEventHook' })

  const sendEvent = useCallback(
    async (eventName: string) => {
      if (!userId)
        return

      try {
        const { success } = await optimizelyClient.onReady()
        if (!success)
          return

        optimizelyClient.track(eventName, userId, { page: window.location.href })
      }
      catch (error) {
        newRelicLogger.logError(error instanceof Error ? error : new Error('[useSendOptimizelyEvent] Optimizely client failed to initialise'))
      }
    },
    [userId],
  )

  return { sendEvent }
}
